'use client';
import JDIPrice from '@/components/price';
import { useTranslation } from '@/i18n/client';
import { EXPOSURE_RECORD, sendClickTrack, type IExpoTrackParamsRecord } from '@/tracks/32896';
import pageSDK from '@/utils/goToPage';
import { imageUtil } from '@/utils/imageUtil';
import { useEffect, useRef, useState } from 'react';
import ProductImg from '../ProductImg';
import style from './index.module.scss';
function Index(props: {
  skuInfo: any;
  eventTrackingInfo: any;
  currencySymbol: string;
  localInfo: any;
}) {
  const { skuInfo, currencySymbol, localInfo } = props || {};
  const { t } = useTranslation();
  const [originalDisplay, setOriginalDisplay] = useState<boolean>(true);
  const currency = currencySymbol;
  const containerRef = useRef<HTMLDivElement>(null);
  const realPriceRef = useRef<HTMLDivElement>(null);
  const originPriceRef = useRef<HTMLDivElement>(null);
  const jsonParams: IExpoTrackParamsRecord['Activity_Discount_ProductExpo'] = {
    ...props.eventTrackingInfo,
  };

  useEffect(() => {
    setTimeout(() => {
      checkPriceOverflow();
    }, 30);
  }, []);

  // 点击商品卡片跳转
  const clickCard = () => {
    sendClickTrack.Activity_Discount_Product({ ...jsonParams });
    const jump = skuInfo.jumpUrl;
    if (jump) {
      pageSDK.goToPage(jump);
    } else {
      pageSDK.goToProduct(skuInfo);
    }
  };

  /**
   * 判断原价是否大于现价
   * @params originalPrice 原价
   * @params realPrice 现价
   * @return Boolean
   */
  const comparePrice = (originalPrice: any, realPrice: any): boolean => {
    return Number(realPrice) < Number(originalPrice);
  };

  // 跳转商详页
  const jumpProductDetail = (event: React.MouseEvent<HTMLDivElement>, product: any) => {
    sendClickTrack.Activity_Discount_BuyNow({ ...jsonParams });
    event.stopPropagation();
    pageSDK.goToProduct(product);
  };

  // 当前单品的价格显示的极限设计的是到十万位，如果金额及划线价长度溢出展示不下，则划线价隐藏。
  const checkPriceOverflow = () => {
    const priceElement = realPriceRef.current;
    const originalPriceElement = originPriceRef.current;

    // 容器宽度
    const containerElement = containerRef.current;

    if (priceElement && originalPriceElement && containerElement) {
      const priceWidth = priceElement.clientWidth;
      const originalPriceWidth = originalPriceElement.clientWidth;
      const containerWidth = containerElement.clientWidth;

      // 如果价格宽度加上划线价宽度超出容器宽度，则隐藏划线价 5为价格之间的间距
      setOriginalDisplay(priceWidth + originalPriceWidth <= containerWidth);
    }
  };

  return (
    <div
      className={style.product_card}
      onClick={clickCard}
      exptag={'exp|' + EXPOSURE_RECORD.Activity_Discount_ProductExpo}
      data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.5}'
      data-exptag-json-param={JSON.stringify(jsonParams)}
    >
      {/* <div className={style.product_card}> */}
      <div className={style.product_img}>
        <ProductImg src={imageUtil.concatImgUrlWithoutForceHttps(skuInfo?.imageUrl)} />
      </div>
      <div className={style.product_info}>
        {/* style={{ ...productNameStyle }} */}
        <div className={style.product_name}>{skuInfo?.skuName}</div>
        {/* 价格展示 */}
        <div className={style.product_price_wrap} ref={containerRef}>
          {/* 商品价 */}
          {/* style={{ ...productPriceStyle }} */}
          {[null, undefined, ''].includes(skuInfo?.realPrice) ? (
            <span className={style.no_price_style}>{t('cms.ukH5ProductActivity.noPriceText')}</span>
          ) : (
            <div ref={realPriceRef}>
              <JDIPrice
                locale={localInfo?.languageCode}
                currency={localInfo?.currencyCode}
                price={skuInfo?.realPrice}
                uiType={1}
                containerStyle={{
                  marginRight: '4px',
                  color: '#CC0C1C',
                  lineHeight: '20px',
                  fontSize: '14px',
                  height: '20px',
                }}
                integerStyle={{
                  fontSize: '20px',
                  lineHeight: '20px',
                }}
              />
            </div>
          )}
          {/* 划线价 */}
          {originalDisplay && comparePrice(skuInfo?.originalPrice, skuInfo?.realPrice) ? (
            <div ref={originPriceRef}>
              <JDIPrice
                locale={localInfo?.languageCode}
                currency={localInfo?.currencyCode}
                price={skuInfo?.originalPrice}
                uiType={2}
                lineThrough
                containerStyle={{
                  fontSize: '12px',
                  lineHeight: '12px',
                  height: '12px',
                  color: 'rgba(25, 25, 27, 0.5)',
                }}
              />
            </div>
          ) : null}
        </div>
        {/* buy now */}
        {skuInfo?.stock ? (
          <div className={style.buy_now_btn} onClick={(e) => jumpProductDetail(e, skuInfo)}>
            {t('cms.ukH5ProductActivity.buyNowBtn')}
          </div>
        ) : (
          <div
            className={`${style.buy_now_btn} ${style.out_of_stock_btn}`}
            onClick={(e) => jumpProductDetail(e, skuInfo)}
          >
            {t('cms.ukH5ProductActivity.outOfStockBtn')}
          </div>
        )}
      </div>
    </div>
  );
}

export default Index;
